var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7752 6.55822C14.9251 8.01968 16 8.75042 16 10.0002C16 11.25 14.9251 11.9808 12.7752 13.4422C12.1817 13.8457 11.5931 14.2255 11.0522 14.542C10.5777 14.8197 10.0403 15.1069 9.48387 15.3889C7.33906 16.4758 6.26666 17.0192 5.30483 16.4176C4.343 15.8159 4.25559 14.5563 4.08076 12.0371C4.03132 11.3247 4 10.6263 4 10.0002C4 9.37412 4.03132 8.67572 4.08076 7.9633C4.25559 5.44414 4.343 4.18456 5.30483 3.58288C6.26666 2.9812 7.33906 3.52464 9.48387 4.61153C10.0403 4.89349 10.5777 5.18073 11.0522 5.45841C11.5931 5.77493 12.1817 6.15478 12.7752 6.55822Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.2794220022619c5132d43c5ca4e8c82b.svg";
export { ForwardRef as ReactComponent };